<template>
  <div id="slideWindowCont"> <!-- So css transitions don't overlap with vue's -->
    <div id="slideWindow">
      <div id="logoCont">
        <transition name="logo-slide">
          <div id="logoTransDiv" v-show="navIsOpen">
            <h1>
              <b>BERG</b> ENTERPRISES
            </h1>
          </div>
       </transition>
      </div>
      <nav>
        <div id="linkCont">
          <HeaderLink v-for="link in navLinks"
            
            :key="link.title"
            :linkTitle="link.name"
            :linkDest="link.el"
            />
          </div>
      </nav>
    </div>
  </div>
</template>

<script>
import HeaderLink from '../nav/HeaderLink.vue'
  
export default {
  name: 'SlideoverNav',
  components: {
    HeaderLink
  },
  
  data() {
    return {
      
    }
  },

  computed: {
    navLinks() {
      return this.$store.state.nav.links;
    },
    navIsOpen() {
      return this.$store.state.nav.isOpen;
    }
  }
}

</script>

<style scoped>

  #slideWindowCont {
    z-index: 100;
    width: 75%;
    position: fixed;
    max-width: 300px;
    min-width: 240px;
    height: 100%;
    position: fixed;
    border: solid yellow 0px;
    box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.2);
  }
  
  #slideWindow {
    width: 100%;
    height: 100%;
    border: solid red 0px;
    background-image: linear-gradient(180deg, rgba(250,250,250,1) 0%, rgba(250,250,250,1) 1%, rgba(250,250,250,0.9) 10%, rgba(11,7,22,1) 90%, rgba(11,7,22,1) 91%, rgba(11,7,22,0.9) 100%);
    background-size: 100% 1000%;
    background-position: var(--nav-grad-pos);
    transition: background-position, 400ms;    
    display: flex;
    flex-direction: column;
  }

  nav {
    border: solid green 0px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin: 0px 25px 0px 0px;
  }
  
  h1 {
    font-family: Futura,Trebuchet MS,Arial,sans-serif;
    font-weight: normal;
    font-size: 22px;
    text-shadow: 0px 1px 3px rgba(0, 0, 0, .2);
    width: 218px;
    height: 30px;
    border: solid green 0px;
    text-align: center;
    color: var(--logo-text);
    transition-duration: 1000ms;
    position: relative;
    border: solid blue 0px;
  }
  
  #logoTransDiv {
    width: 218px;
    height: 30px;
    position: relative;
    border: solid yellow 0px;
  }

  #linkCont {
    border: solid yellow 0px;
    width: 100px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
  
  #logoCont {
    border: solid yellow 0px;
    height: 60px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    position: relative;
  }
  
  #logoText {
    width: 207px;
    height: 27px;
    transform: translateY(2px);
  }
  
  /* Vue Transitions */
  
  .logo-slide-enter-active, .logo-slide-leave-active {
    transition: transform 600ms cubic-bezier(.47,0,.32,1), opacity 1100ms cubic-bezier(.47,0,.32,1);
    transform: translateX(0px);
    opacity: 1;
  }
  
  .logo-slide-enter, .logo-slide-leave-to {
    transition: transform 600ms cubic-bezier(.47,0,.32,1), opacity 300ms cubic-bezier(.47,0,.32,1);
    transform: translateX(45px);
    opacity: 0;
  }


</style>
